<template>
  <SideBarLayout style="background: #F7FAFE">
    <template v-slot:sidebar>
      <RequestSideBar
        ref="sideBar"
        :requestor="requestor"
        :tab="tab"
        @change:requestor="handleChangeRequestor"
        @research="loadApplicants"
      />
    </template>

    <template v-slot:context>
      <FlexColumn :space="2" class="mx-4 mt-4 results">
        <FlexRow
          justify="space-between"
          :style="{
            'flex-direction': $vuetify.breakpoint.mdAndDown ? 'column !important' : undefined,
            'gap': $vuetify.breakpoint.mdAndDown ? '20px' : '12px'
          }"
        >
          <FlexColumn style="flex: 1 1 0; max-width: 1000px">
            <RequestTickets />
            
            <FlexColumn :space="0" class="mt-3" style="flex: 1">
              <Label text="スカウト対象求人" bold />
              <SimpleSelectField
                :value="jobId"
                :items="selectJobs"
                simple
                class="pt-0 mt-0"
                @input="handleChangeJob"
              />
            </FlexColumn>
          </FlexColumn>
          
          <RequestTemplateCard
            style="flex: 1 1 0; max-width: 640px"
            :requestor="requestor"
            @change:requestor="handleChangeRequestor"
          />
        </FlexRow>

        <FlexColumn class="mt-7">
          <Label v-if="selectedSearchConditionSet !== undefined" size="h5" bold :text="selectedSearchConditionSet.name" />
          <FlexRow justify="space-between">
            <FlexRow :space="4" align="center">
              <Label size="h6" bold :text="`${title}`" style="flex-shrink: 0" class="mr-0"/>
              <Label size="body-2" bold :text="`(${applicantCount || 0}件中${page}ページ目)`" style="flex-shrink: 0"/>
              <Label :text="description" size="body-2"/>
            </FlexRow>

            <FlexRow>
              <Button v-if="hasSearchingCondition" text small @click="resetSearchingCondition">
                <Label text="検索条件リセット" size="body-2" color="tertiary" />
              </Button>
              <ApplicantSearchConditionsSaveButton
                  v-if="hasSearchingCondition"
                  :andKeyword="queryAndKeyword"
                  :orKeyword="queryOrKeyword"
                  :data="queryData"
                  :dataType="queryDataType"
                  :currentPrefectures="queryCurrentPrefectures"
                  :prefectures="queryPrefectures"
                  :positions="queryPositions"
                  :medalist="queryMedalist"
                  :newcomer="queryNewcomer"
                  :scoutable="queryScoutable"
                  :salary="{lower: querySalaryLower, upper: querySalaryUpper}"
                  :gender="queryGender"
                  :age="{lower: queryAgeLower, upper: queryAgeUpper}"
                  small
              />
              <ApplicantSearchConditionSetUpdateButton
                  v-if="selectedSearchConditionSet !== undefined"
                  :andKeyword="queryAndKeyword"
                  :orKeyword="queryOrKeyword"
                  :data="queryData"
                  :dataType="queryDataType"
                  :currentPrefectures="queryCurrentPrefectures"
                  :prefectures="queryPrefectures"
                  :positions="queryPositions"
                  :medalist="queryMedalist"
                  :newcomer="queryNewcomer"
                  :scoutable="queryScoutable"
                  :salary="{lower: querySalaryLower, upper: querySalaryUpper}"
                  :gender="queryGender"
                  :age="{lower: queryAgeLower, upper: queryAgeUpper}"
                  small
              />
            </FlexRow>
          </FlexRow>
          <FlexRow>
            <Label text="転職を検討している可能性が高い候補者順に並んでいます。" size="body-2" />
          </FlexRow>
        </FlexColumn>

        <ApplicantCards :requestorId="requestorId" @click:detail="handleClickDetail" @click:ignoreApplicant="handleIgnoreApplicant" />

        <FlexRow justify="center" class="mb-4">
          <Button
            :disabled="disabledPrev"
            outlined
            class="cancel-keep-active"
            @click="prevPage"
          >
            <v-icon>mdi-menu-left</v-icon>
            前
          </Button>
          <Button
            :disabled="disabledNext"
            outlined
            class="cancel-keep-active"
            @click="nextPage"
          >
            次
            <v-icon>mdi-menu-right</v-icon>
          </Button>
        </FlexRow>
      </FlexColumn>
      <ApplicantDetailPanel
          :open="detailApplicant !== undefined"
          :applicant="detailApplicant"
          :targetJob="targetJob"
          :requestorId="requestorId"
          @close="detailApplicantId = undefined"
          @prev="handlePrevDetailApplicant"
          @next="handleNextDetailApplicant"
      />
      <v-snackbar v-model="message.open" top>{{message.text}}</v-snackbar>
    </template>
  </SideBarLayout>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import SideBarLayout from "@/components/templates/SideBarLayout";
import RequestSideBar from "@/components/organisms/RequestSideBar";
import Label from "@/components/atoms/Label";
import FlexRow from "@/components/atoms/FlexRow";
import ApplicantSearchConditionsSaveButton from "@/components/molecules/ApplicantSearchConditionsSaveButton";
import ApplicantCards from "@/components/organisms/ApplicantCards";
import FlexColumn from "@/components/atoms/FlexColumn";
import ApiMixin from "@/ApiMixin";
import {mapGetters} from "vuex";
import {Mutex} from "await-semaphore";
import Button from "../../atoms/Button";
import SimpleSelectField from '../../atoms/SimpleSelectField'
import RequestTickets from '../../organisms/RequestTickets'
import RequestTemplateCard from '../../organisms/RequestTemplateCard'
import ApplicantSearchConditionSetUpdateButton from "../../organisms/ApplicantSearchConditionSetUpdateButton";
import ApplicantDetailPanel from "../../organisms/ApplicantDetailPanel";

export default {
  components: {
    ApplicantDetailPanel,
    ApplicantSearchConditionSetUpdateButton,
    RequestTemplateCard,
    RequestTickets,
    SimpleSelectField,
    Button,
    FlexColumn, ApplicantCards, ApplicantSearchConditionsSaveButton, FlexRow, Label, RequestSideBar, SideBarLayout},
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "ChatRequestPage",
  data() {
    return {
      page: 0,
      mutex: undefined,
      requestorId: undefined,
      jobId: undefined,
      detailApplicantId: undefined,
      waitDetailApplicant: undefined,
      message: {
        open: false,
        text: ""
      }
    }
  },
  beforeMount() {
    this.mutex = new Mutex()
    this.$store.dispatch("system/updateSideBarStatus", {status: "show"})
    this.requestorId = this.$cookies.get('nishika.chat-requests-requestor')

    this.jobId = this.$route.params.id
  },
  mounted() {
  },
  destroyed() {
    this.$store.dispatch("system/updateSideBarStatus", {status: "hide"})
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    ...mapGetters("chatRequests", ["jobs"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("chatRequests", ["lists", "applicantCount", "selectedSearchConditionSet", "applicants"]),
    ...mapGetters("client", ["company", "requestors"]),
    title() {
      const list = this.query.list
      if (list) {
        switch(list) {
          case "favorite":
            return "お気に入り一覧"
          case "hidden":
            return "非表示一覧"
          default:
            return "作成したリスト"
        }
      }
      if (this.query.requested) {
        return "スカウト済一覧"
      }
      if (this.query.signal) {
        return "Hotリスト"
      }
      if (Object.keys(this.query).length > 0) {
        return "検索条件"
      }
      return "おすすめの候補者"
    },
    tab () {
      if (this.isListQuery) return 1;
      return 0
    },
    isListQuery () {
      return this.query.list || this.query.requested || this.query.signal
    },
    description() {
      const list = this.query.list
      if (list) {
        switch(list) {
          case "favorite":
            return "お気に入りで一時保存した候補者です"
          case "hidden":
            return ""
          default:
            return `リスト名：${this.listName}`
        }
      }
      if (this.query.requested) {
        return "60日以内にスカウトを送信した候補者です"
      }
      if (Object.keys(this.query).length > 0) {
        return this.searchConditionsText
      }
      return ""
    },
    listName() {
      const list = this.query.list
      const results = this.lists.filter(item => item.id === list)
      if (results.length > 0) {
        return results[0].name
      }
      return ""
    },
    hasSearchingCondition() {
      return !this.isListQuery && Object.keys(this.query).length > 0
    },
    searchConditionsText() {
      const conditions = []
      if (this.queryAndKeyword) {
        conditions.push(`キーワード（すべてを含む）：${this.queryAndKeyword}`)
      }
      if (this.queryOrKeyword) {
        conditions.push(`キーワード（いずれかを含む）：${this.queryOrKeyword}`)
      }
      if (this.queryData && this.queryData.length > 0) {
        conditions.push(`経験のあるデータ：${this.dataLabel(this.queryData)}`)
      }
      if (this.queryCurrentPrefectures && this.queryCurrentPrefectures.length > 0) {
        conditions.push(`現在の居住地：${this.prefecturesLabel(this.queryCurrentPrefectures)}`)
      }
      if (this.queryPrefectures && this.queryPrefectures.length > 0) {
        conditions.push(`希望勤務地：${this.prefecturesLabel(this.queryPrefectures)}`)
      }
      if (this.queryPositions && this.queryPositions.length > 0) {
        conditions.push(`経験のある職種：${this.positionsLabel(this.queryPositions)}`)
      }
      if (this.querySalaryLower || this.querySalaryUpper) {
        conditions.push(`現在の年収：${this.querySalaryLower || ''} ~ ${this.querySalaryUpper || ''} 万円`)
      }
      if (this.queryGender === 0 || this.queryGender === 1 || this.queryGender === 2) {
        conditions.push(`性別：${this.convertGender(this.queryGender)}`)
      }
      if (this.queryAgeLower || this.queryAgeUpper) {
        conditions.push(`年齢：${this.queryAgeLower || ''} ~ ${this.queryAgeUpper || ''}`)
      }
      if (this.queryMedalist) {
        conditions.push(`コンペ成績：コンペ上位者`)
      }
      if (this.queryNewcomer) {
        conditions.push(`新規登録者のみ`)
      }
      if (this.queryScoutable) {
        conditions.push(`スカウト送付可能のみ`)
      }
      return conditions.join(" | ")
    },
    dataLabel() {
      return (data) => {
        if (data && data.length > 0) {
          return data.map(item => this.constsToText(item, this.consts.dataGoodAt)).join("、")
        }
        return ""
      }
    },
    prefecturesLabel() {
      return (prefectures) => {
        if (prefectures && prefectures.length > 0) {
          return prefectures.map(item => this.constsToText(item, this.consts.preferredLocation)).join("、")
        }
        return ""
      }
    },
    positionsLabel() {
      return (positions) => {
        if (positions && positions.length > 0) {
          return positions.map(item => this.constsToText(item, this.consts.currentJob)[0]).join("、")
        }
        return ""
      }
    },
    query() {
      return this.$route.query
    },
    queryAndKeyword() {
      return this.query.andKeyword
    },
    queryOrKeyword() {
      return this.query.orKeyword
    },
    queryData() {
      return this.toIntValues(this.query.data)
    },
    queryDataType() {
      return this.query.dataType
    },
    queryCurrentPrefectures() {
      return this.toIntValues(this.query.currentPrefectures)
    },
    queryPrefectures() {
      return this.toIntValues(this.query.prefectures)
    },
    queryPositions() {
      return this.toIntValues(this.query.position)
    },
    querySalaryLower() {
      return this.toIntValue(this.query.salaryLower)
    },
    querySalaryUpper() {
      return this.toIntValue(this.query.salaryUpper)
    },
    queryGender() {
      return this.toIntValue(this.query.gender)
    },
    queryAgeLower() {
      return this.toIntValue(this.query.ageLower)
    },
    queryAgeUpper() {
      return this.toIntValue(this.query.ageUpper)
    },
    queryMedalist() {
      const medalist = this.query.medalist
      if (typeof medalist === "string") {
        return this.query.medalist === "true"
      }
      if (typeof medalist === "boolean") {
        return this.query.medalist
      }
      return false
    },
    queryNewcomer() {
      const newcomer = this.query.newcomer
      if (typeof newcomer === "string") {
        return this.query.newcomer === "true"
      }
      if (typeof newcomer === "boolean") {
        return this.query.newcomer
      }
      return false
    },
    queryScoutable() {
      const scoutable = this.query.scoutable
      if (typeof scoutable === "string") {
        return this.query.scoutable === "true"
      }
      if (typeof scoutable === "boolean") {
        return this.query.scoutable
      }
      return false
    },
    requestor() {
      if (this.requestors) {
        return this.requestors.find(requestor => requestor.id === this.requestorId)
      }
      return undefined
    },
    disabledPrev() {
      return this.page === 1
    },
    disabledNext() {
      // todo : BEからのレスポンスにnextの有無で判定するようにする
      const pageSize = this.query.signal ? 100 : 10
      return this.applicantCount != null && this.applicantCount <= this.page * pageSize
    },
    selectJobs() {
      return this.jobs.map(job => ({
        value: job.id,
        label: job.name
      }))
    },
    targetJob() {
      return this.jobs.find(job => job.id === this.jobId) || {}
    },
    detailApplicant() {
      return this.applicants.find(applicant => applicant.id === this.detailApplicantId)
    }
  },
  methods: {
    toIntValue(value) {
      if (typeof value === "string") {
        return parseInt(value)
      }
      return value
    },
    toIntValues(values) {
      if (typeof values === "string") {
        return [parseInt(values)]
      }
      if (values instanceof Array) {
        return values.map(value => parseInt(value))
      }
      return []
    },
    async getCompany() {
      const response = await this.loadCompaniesMe()
      return response.data
    },
    async getTargetJobs(companyId) {
      const response = await this.loadChatRequestTargetJobs(companyId)
      return response.data.jobs
    },
    async loadApplicants(page) {
      page = page || 1  // デフォルト引数がうまく機能しなくなっており、初期読み込み時NoNになって読み込みエラーになっていた

      const params = this.$route.params
      const jobId = params.id
      const list = this.query.list
      const requested = this.query.requested
      const signal = this.query.signal
      if (list) {
        await this.loadChatRequestListApplicants(jobId, list, page)
      } else if (requested) {
        await this.loadChatRequestRequestedApplicants(jobId, page)
      } else if (signal) {
        await this.loadChatRequestSignalListApplicants(jobId, page)
      } else {
        await this.loadChatRequestApplicants(
            jobId,
            page,
            this.queryAndKeyword,
            this.queryOrKeyword,
            this.queryData,
            this.queryDataType,
            this.queryCurrentPrefectures,
            this.queryPrefectures,
            this.queryPositions,
            this.queryAgeLower,
            this.queryAgeUpper,
            this.queryMedalist,
            this.querySalaryLower,
            this.querySalaryUpper,
            this.queryGender,
            this.queryNewcomer,
            this.queryScoutable
        )
      }
      window.scroll({top: 0})
      this.page = page
    },
    nextPage() {
      if (this.disabledNext) return

      this.scrollToTop()
      this.$router.push({
        name: 'RequestsPage',
        params: {
          id: this.$route.params.id
        },
        query: {
          ...this.$route.query,
          page: this.page + 1
        }
      })
    },
    prevPage() {
      if (this.disabledPrev) return

      this.scrollToTop()
      this.$router.push({
        name: 'RequestsPage',
        params: {
          id: this.$route.params.id
        },
        query: {
          ...this.$route.query,
          page: this.page - 1
        }
      })
    },
    handleChangeRequestor(value) {
      this.requestorId = value
    },
    scrollToTop() {
      scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    handleChangeJob(newJob) {
      const expireTimes = 60 * 60 * 24 * 30
      this.$cookies.set('nishika.chat-requests-job', newJob, expireTimes)
      this.jobId = newJob

      this.$router.push({
        name: 'RequestsPage',
        params: {
          id: newJob
        },
        query: this.$route.query,
      })
    },
    convertGender(gender) {
      if (gender === 0) return '男性'
      if (gender === 1) return '女性'
      if (gender === 2) return 'その他'
    },
    resetSearchingCondition() {
      this.$refs.sideBar.$refs.searchForm.handleSearchReset()
    },
    handleClickDetail(applicant) {
      this.putBusinessCandidateDisplay(applicant.id)
      this.detailApplicantId = applicant.id
    },
    handleIgnoreApplicant(applicant) {
      this.addChatRequestListApplicant(this.company.id, applicant.id, "hidden")
    },
    handlePrevDetailApplicant() {
      const index = this.applicants.findIndex(applicant => applicant.id === this.detailApplicant.id)
      if (index === 0) {
        this.waitDetailApplicant = "prev"
        this.prevPage()
      } else {
        this.detailApplicantId = this.applicants[index - 1].id
        this.putBusinessCandidateDisplay(this.applicants[index - 1].id)
      }
    },
    handleNextDetailApplicant() {
      const index = this.applicants.findIndex(applicant => applicant.id === this.detailApplicant.id)
      if (index === this.applicants.length - 1) {
        if (this.disabledNext) {
          this.message.open = true
          this.message.text = "次の候補者がいません"
        } else {
          this.waitDetailApplicant = "next"
          this.nextPage()
        }
      } else {
        this.detailApplicantId = this.applicants[index + 1].id
        this.putBusinessCandidateDisplay(this.applicants[index + 1].id)
      }
    }
  },
  watch: {
    "user.id": {
      handler: async function(value) {
        if (value) {
          const selectedRequestorId = this.$cookies.get('nishika.chat-requests-requestor')
          if (selectedRequestorId == null) {
            await this.$router.push({
              name: "RequestsPageJobSettingPage",
              query: this.$route.query,
            })
            return
          }
          const jobId = this.$route.params.id
          const company = await this.getCompany()
          this.loadChatRequestLists(company.id)
          this.loadChatRequestSearchConditions(company.id)
          this.loadRequestors(company.id)
          const jobs = await this.getTargetJobs(company.id)
          const job = jobs.find(job => job.id === jobId)
          if (job) {
            const page = this.$route.query.page
            await this.loadApplicants( Number(page))
          } else {
            await this.$router.push({
              name: "RequestsPageJobSettingPage",
              query: this.$route.query,
            })
          }
        }
      },
      immediate: true
    },
    "$route": {
      handler: function () {
        const page = this.$route.query.page
        this.loadApplicants(page)
      }
    },
    "company.id": {
      handler: function (value) {
        if (value) {
          this.loadScoutMessageTemplates(value)
        }
      },
      immediate: true
    },
    applicants: {
      handler: function (applicants) {
        if (this.waitDetailApplicant === "prev") {
          this.detailApplicantId = applicants[applicants.length - 1].id
          this.putBusinessCandidateDisplay(applicants[applicants.length - 1].id)
        }
        if (this.waitDetailApplicant === "next") {
          this.detailApplicantId = applicants[0].id
          this.putBusinessCandidateDisplay(applicants[0].id)
        }
        this.waitDetailApplicant = undefined
      }
    }
  }
}
</script>

<style scoped>
.cancel-keep-active:focus::before {
  opacity: 0 !important;
}
</style>
